module.exports = __webpack_public_path__ + "static/media/venus.99a74b94.svg";